import * as React from 'react';

export const Edit = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 18 18" {...props}>
    <path
      fill="currentColor"
      d="M16.933 14.95a1 1 0 0 1 .117 1.993l-.117.006H9.467a1 1 0 0 1-.117-1.993l.117-.007h7.466zM12.487 1.322a2.74 2.74 0 0 1 2.676-.727 2.775 2.775 0 0 1 1.948 1.976 2.813 2.813 0 0 1-.576 2.54l-.133.145-10.37 10.55a1 1 0 0 1-.337.225l-.13.043-3.319.843a1 1 0 0 1-1.238-1.098l.02-.11.83-3.375a1 1 0 0 1 .171-.36l.088-.102 10.37-10.55zm2.039 1.182a.738.738 0 0 0-.526.144l-.087.076L3.735 13.078l-.367 1.491 1.433-.364 10.175-10.35a.806.806 0 0 0 .228-.564l-.006-.105-.02-.104a.781.781 0 0 0-.446-.523l-.095-.033-.111-.021z"
    />
  </svg>
);
